<template>
  <div class="an-root">
    <!-- ── Sidebar ── -->
    <div class="an-sidebar">
      <!-- Botão Voltar no topo -->
      <button class="an-back-btn" type="button" @click="Voltar">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
          <path d="M19 12H5M5 12l7 7M5 12l7-7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Voltar ao vídeo
      </button>

      <div class="an-sidebar-divider"></div>

      <div class="an-sidebar-header">
        <div class="an-header-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M18 20V10M12 20V4M6 20v-6" stroke="#E86A10" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="an-header-title">Analytics</div>
        <div class="an-header-sub">Métricas & Performance</div>
      </div>

      <nav class="an-nav">
        <button
          class="an-nav-item"
          :class="{ 'an-nav-active': aba === 'estatisticas' }"
          @click="aba = 'estatisticas'"
        >
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
            <path d="M18 20V10M12 20V4M6 20v-6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>
          </svg>
          Estatísticas
        </button>

        <button
          class="an-nav-item"
          :class="{ 'an-nav-active': aba === 'ia' }"
          @click="aba = 'ia'"
        >
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
            <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Análise de IA
          <span class="an-nav-badge">IA</span>
        </button>
      </nav>
    </div>

    <!-- ── Área principal ── -->
    <div class="an-body">
      <detalhes v-if="aba === 'estatisticas'" />
      <analise-ia v-if="aba === 'ia'" />
    </div>
  </div>
</template>

<script>
import { BTabs, BTab } from 'bootstrap-vue'
import Detalhes from './Detalhes.vue'
import AnaliseIA from './AnaliseIA.vue'

export default {
  components: { BTabs, BTab, Detalhes, 'analise-ia': AnaliseIA },
  data() {
    return {
      vslId: this.$route.params.vslId,
      aba: this.$route.query.tab === 'ia' ? 'ia' : 'estatisticas',
    }
  },
  methods: {
    Voltar() {
      this.$router.push(`/player/${this.vslId}`)
    },
  },
}
</script>

<style scoped>
.an-root {
  display: flex;
  flex-direction: row;
  min-height: calc(100vh - 62px);
  background: var(--dk-bg-page, #F0F3F7);
  font-family: -apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', sans-serif;
}

/* Sidebar */
.an-sidebar {
  width: 240px;
  min-width: 240px;
  background: var(--dk-bg-card, #fff);
  box-shadow: 2px 0 12px rgba(13,51,73,0.07);
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 10;
}
.an-back-btn {
  display: flex; align-items: center; gap: 8px;
  width: 100%;
  padding: 14px 16px;
  border: none;
  background: none;
  font-size: 13px; font-weight: 600; color: var(--dk-text-primary, #3D4A5C);
  cursor: pointer; transition: color 0.15s;
  font-family: inherit;
}
.an-back-btn svg { color: #E86A10; }
.an-back-btn:hover { color: #E86A10; }
.an-sidebar-divider { height: 1px; background: var(--dk-border-light, #F0F3F7); }
.an-sidebar-header {
  padding: 20px 20px 16px;
  border-bottom: 1.5px solid var(--dk-border-light, #F0F3F7);
}
.an-header-icon {
  width: 46px; height: 46px;
  background: linear-gradient(135deg, rgba(232,106,16,0.12) 0%, rgba(232,106,16,0.08) 100%);
  border: 1.5px solid rgba(232,106,16,0.2);
  border-radius: 12px;
  display: flex; align-items: center; justify-content: center;
  margin-bottom: 12px;
}
.an-header-title {
  font-size: 17px; font-weight: 900; color: var(--dk-text-primary, #0D3349); line-height: 1.2;
}
.an-header-sub {
  font-size: 11.5px; color: var(--dk-text-muted, #94a3b8); margin-top: 2px;
}

.an-nav { padding: 12px; flex: 1; display: flex; flex-direction: column; gap: 4px; }
.an-nav-item {
  display: flex; align-items: center; gap: 8px;
  padding: 10px 12px; border-radius: 10px;
  font-size: 13px; font-weight: 600; color: var(--dk-text-secondary, #64748b);
  cursor: pointer; transition: all 0.15s;
  border: none; background: transparent; width: 100%; text-align: left;
}
.an-nav-item:hover { background: var(--dk-bg-card-hover, #F8FAFB); color: var(--dk-text-primary, #0D3349); }
.an-nav-active {
  background: rgba(232,106,16,0.1) !important;
  color: #E86A10 !important;
  font-weight: 800;
}
.an-nav-badge {
  margin-left: auto;
  font-size: 9px; font-weight: 800;
  padding: 2px 6px; border-radius: 6px;
  background: linear-gradient(135deg, #E86A10, #F5B935);
  color: #fff; letter-spacing: 0.5px;
}


/* Body */
.an-body {
  flex: 1;
  min-width: 0;
  padding: 0;
  overflow-y: auto;
  background: #0D1117;
}
</style>
